
export function isValidTopology(results) {
  return !results.some(({ state }) => state === 'INVALID');
}